<template>
  <navBack></navBack>
  <view class="page">
    <view class="header">
      <t-cell title="大工" :bordered="false" />
    </view>

    <view class="content">
      <block v-for="(item, index) in dgList" :key="item._id">
        <view class="userItem">
          <view v-if="dg._id === item._id" class="checkZd">
            <t-switch 
              v-model="dg.zd" 
              :label="['指定']" 
              :custom-style="{ margin: '0 10rpx' }"
              @change="checkChange2('dg', '大工')"
            />
          </view>
          <view 
            @click="choseThisService('dg', index)" 
            class="item"
            :class="{ checked: dg._id === item._id }"
          >
            {{ item.name }}
          </view>
        </view>
      </block>
    </view>

    <t-cell title="中工" :bordered="false" />

    <view class="content">
      <block v-for="(item, index) in zgList" :key="item._id">
        <view class="userItem">
          <view v-if="zg._id === item._id" class="checkZd">
            <t-switch 
              v-model="zg.zd" 
              :label="['指定']" 
              :custom-style="{ margin: '0 10rpx' }"
              @change="checkChange2('zg', '中工')"
            />
          </view>
          <view 
            @click="choseThisService('zg', index)" 
            class="item"
            :class="{ checked: zg._id === item._id }"
          >
            {{ item.name }}
          </view>
        </view>
      </block>
    </view>

    <view class="header">
      <t-cell title="小工" :bordered="false" />
    </view>

    <view class="content">
      <block v-for="(item, index) in xgList" :key="item._id">
        <view class="userItem">
          <view v-if="xg._id === item._id" class="checkZd">
            <t-switch 
              v-model="xg.zd" 
              :label="['指定']" 
              :custom-style="{ margin: '0 10rpx' }"
              @change="checkChange2('xg', '小工')"
            />
          </view>
          <view 
            @click="choseThisService('xg', index)" 
            class="item"
            :class="{ checked: xg._id === item._id }"
          >
            {{ item.name }}
          </view>
        </view>
      </block>
    </view>

    <t-submit-bar @submit="doConfirm" submit-text="确定">
     
    </t-submit-bar>
  </view>
</template>

<script setup>
import { ref, reactive } from 'vue'
 
 import navBack  from '@/components/nav-back.vue'

// 响应式数据
const dgList = ref([])
const zgList = ref([])
const xgList = ref([])

const dg = reactive({
  _id: '',
  zd: false
})

const zg = reactive({
  _id: '',
  zd: false
})

const xg = reactive({
  _id: '',
  zd: false
})

// 选择服务
const choseThisService = (type, index) => {
  console.log('选择服务:', type, index)
  // 根据类型处理选择逻辑
  switch (type) {
    case 'dg':
      dg._id = dgList.value[index]._id
      break
    case 'zg':
      zg._id = zgList.value[index]._id
      break
    case 'xg':
      xg._id = xgList.value[index]._id
      break
  }
}

// 指定开关变更
const checkChange2 = (type, name) => {
  console.log('指定开关变更:', type, name)
  // 处理指定开关变更逻辑
}

// 确认选择
const doConfirm = () => {
  console.log('确认选择')
  // 处理确认逻辑
}

 
// 加载数据
const loadData = async () => {
  try {
    // 这里应该调用实际的API获取数据
    // 示例数据
    dgList.value = [
      { _id: '1', name: '张三' },
      { _id: '2', name: '李四' }
    ]
    
    zgList.value = [
      { _id: '3', name: '王五' },
      { _id: '4', name: '赵六' }
    ]
    
    xgList.value = [
      { _id: '5', name: '孙七' },
      { _id: '6', name: '周八' }
    ]
  } catch (error) {
    console.error('加载数据失败:', error)
  }
}

// 初始化数据
loadData()
</script>

<style scoped>
.page {
  padding-bottom: 100px;
}

.header {
  margin-top: 20px;
}

.content {
  padding: 0 20px;
}

.userItem {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.checkZd {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.item {
  flex: 1;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.item.checked {
  background-color: #007aff;
  color: white;
}

.smallBtn {
  margin-right: 20px;
  color: #007aff;
  font-size: 28px;
}
</style>